import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "taphouse.adminSidebarCollapsed"

export default class extends Controller {
  static targets = ["sidebar", "reopenButton"]
  static values = { collapsed: Boolean }

  connect() {
    this.collapsedValue = this.readStoredState()
    this.applyState()
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    this.applyState()
  }

  collapsedValueChanged() {
    this.applyState()
  }

  applyState() {
    this.element.classList.toggle("admin-sidebar-collapsed", this.collapsedValue)
    this.applyDesktopVisibility()
    this.persistState()
    this.updateLabels()
  }

  applyDesktopVisibility() {
    if (!this.hasSidebarTarget) return

    const desktop = window.matchMedia("(min-width: 1024px)").matches
    this.sidebarTarget.style.display = desktop && this.collapsedValue ? "none" : ""

    if (this.hasReopenButtonTarget) {
      this.reopenButtonTarget.style.display = desktop && this.collapsedValue ? "inline-flex" : "none"
    }
  }

  updateLabels() {
    if (this.hasSidebarTarget) {
      const collapseButton = this.sidebarTarget.querySelector("[data-admin-sidebar-collapse]")
      if (collapseButton) {
        collapseButton.setAttribute("aria-pressed", this.collapsedValue ? "true" : "false")
        collapseButton.setAttribute("aria-label", "Collapse admin navigation")
        collapseButton.setAttribute("title", "Collapse navigation")
      }
    }

    if (this.hasReopenButtonTarget) {
      this.reopenButtonTarget.setAttribute("aria-pressed", this.collapsedValue ? "true" : "false")
      this.reopenButtonTarget.setAttribute("aria-label", "Expand admin navigation")
      this.reopenButtonTarget.setAttribute("title", "Expand navigation")
    }
  }

  readStoredState() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === "true"
    } catch (_error) {
      return false
    }
  }

  persistState() {
    try {
      window.localStorage.setItem(STORAGE_KEY, this.collapsedValue ? "true" : "false")
    } catch (_error) {
      // Ignore storage failures and keep the UI working for the current session.
    }
  }
}
